/**
 * oddit-section-main-collection
 * Interactive behaviors: filter drawer, sort dropdown, accordion filters, load more,
 * product swatches (delegated — works with Load more appends)
 */
(function () {
  'use strict';

  /* Card-level behaviors (carousel, swatches, quick-add, lazy video) are now
     handled globally by oddit-collection-product-card.js */

  function initSection(sectionEl) {
    if (!sectionEl) return;

    var section = sectionEl;

    /* ====================================================================
       Filter Drawer
       ==================================================================== */
    var filterBtn = section.querySelector('.oddit-section-main-collection__filter-btn');
    var drawer = section.querySelector('.oddit-section-main-collection__filter-drawer');
    var drawerOverlay = section.querySelector('.oddit-section-main-collection__drawer-overlay');
    var drawerClose = section.querySelector('.oddit-section-main-collection__drawer-close');

    function openDrawer() {
      if (!drawer || !drawerOverlay) return;
      var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.paddingRight = scrollbarWidth + 'px';
      drawer.classList.add('oddit-section-main-collection__filter-drawer--open');
      drawer.setAttribute('aria-hidden', 'false');
      if (filterBtn) filterBtn.setAttribute('aria-expanded', 'true');
      drawerOverlay.classList.add('oddit-section-main-collection__drawer-overlay--active');
      document.body.style.overflow = 'hidden';
      if (drawerClose) drawerClose.focus();
    }

    function closeDrawer() {
      if (!drawer || !drawerOverlay) return;
      drawer.classList.remove('oddit-section-main-collection__filter-drawer--open');
      drawer.setAttribute('aria-hidden', 'true');
      if (filterBtn) filterBtn.setAttribute('aria-expanded', 'false');
      drawerOverlay.classList.remove('oddit-section-main-collection__drawer-overlay--active');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
      if (filterBtn) filterBtn.focus();
    }

    if (filterBtn) {
      filterBtn.addEventListener('click', openDrawer);
    }

    if (drawerClose) {
      drawerClose.addEventListener('click', closeDrawer);
    }

    if (drawerOverlay) {
      drawerOverlay.addEventListener('click', closeDrawer);
    }

    // Close drawer on Escape
    function handleKeydown(e) {
      if (!drawer || !drawer.classList.contains('oddit-section-main-collection__filter-drawer--open')) return;
      if (e.key === 'Escape') {
        closeDrawer();
      } else if (e.key === 'Tab') {
        var focusable = drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
    document.addEventListener('keydown', handleKeydown);

    /* ====================================================================
       Filter Accordion Groups
       ==================================================================== */
    var filterHeaders = section.querySelectorAll('.oddit-section-main-collection__filter-group-header');

    filterHeaders.forEach(function (header) {
      header.addEventListener('click', function () {
        var group = header.closest('.oddit-section-main-collection__filter-group');
        var content = group.querySelector('.oddit-section-main-collection__filter-group-content');
        var isExpanded = header.getAttribute('aria-expanded') === 'true';

        if (isExpanded) {
          header.setAttribute('aria-expanded', 'false');
          content.setAttribute('hidden', '');
          group.setAttribute('data-open', 'false');
        } else {
          header.setAttribute('aria-expanded', 'true');
          content.removeAttribute('hidden');
          group.setAttribute('data-open', 'true');
        }
      });
    });

    /* ====================================================================
       Filter Form
       ==================================================================== */
    var filterForm = section.querySelector('[data-filter-form]');

    // A ticked size also sends "In stock", so sold-out sizes drop out.
    var sizeInStock = filterForm && filterForm.querySelector('[data-size-in-stock]');
    if (sizeInStock) {
      filterForm.addEventListener('change', function () {
        var sizeParam = sizeInStock.getAttribute('data-size-in-stock');
        var ticked = Array.prototype.some.call(
          filterForm.querySelectorAll('input[type="checkbox"]:checked'),
          function (box) { return box.name === sizeParam; }
        );
        sizeInStock.disabled = !ticked;
      });
    }

    // Keep each group heading's "(n)" in step with what is ticked, so a
    // collapsed group still shows it has selections.
    if (filterForm) {
      filterForm.addEventListener('change', function () {
        filterForm.querySelectorAll('.oddit-section-main-collection__filter-group').forEach(function (group) {
          var label = group.querySelector('[data-filter-selected]');
          if (!label) return;
          var count = group.querySelectorAll('input[type="checkbox"]:checked').length;
          if (!count) {
            var priceInputs = group.querySelectorAll('input[type="number"]');
            for (var i = 0; i < priceInputs.length; i++) {
              if (priceInputs[i].value !== '') { count = 1; break; }
            }
          }
          label.textContent = count ? ' (' + count + ')' : '';
        });
      });
    }

    /* ====================================================================
       Sort Dropdown
       ==================================================================== */
    var sortTrigger = section.querySelector('.oddit-section-main-collection__sort-trigger');
    var sortDropdown = section.querySelector('.oddit-section-main-collection__sort-dropdown');
    var sortValueEl = section.querySelector('.oddit-section-main-collection__sort-value');

    function openSortDropdown() {
      if (!sortTrigger || !sortDropdown) return;
      sortTrigger.setAttribute('aria-expanded', 'true');
      sortDropdown.removeAttribute('hidden');
    }

    function closeSortDropdown() {
      if (!sortTrigger || !sortDropdown) return;
      sortTrigger.setAttribute('aria-expanded', 'false');
      sortDropdown.setAttribute('hidden', '');
    }

    if (sortTrigger && sortDropdown) {
      sortTrigger.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = sortTrigger.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          closeSortDropdown();
        } else {
          openSortDropdown();
        }
      });

      sortTrigger.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          openSortDropdown();
          var options = Array.prototype.slice.call(sortDropdown.querySelectorAll('[role="option"]'));
          var selected = sortDropdown.querySelector('[role="option"][aria-selected="true"]');
          var target = selected || (e.key === 'ArrowUp' ? options[options.length - 1] : options[0]);
          if (target) target.focus();
        }
      });

      sortDropdown.addEventListener('keydown', function (e) {
        var options = Array.prototype.slice.call(sortDropdown.querySelectorAll('[role="option"]'));
        var index = options.indexOf(document.activeElement);
        if (index < 0) return;
        var targetIndex = index;
        if (e.key === 'ArrowDown') targetIndex = (index + 1) % options.length;
        else if (e.key === 'ArrowUp') targetIndex = (index - 1 + options.length) % options.length;
        else if (e.key === 'Home') targetIndex = 0;
        else if (e.key === 'End') targetIndex = options.length - 1;
        else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); document.activeElement.click(); return; }
        else if (e.key === 'Escape') { e.preventDefault(); closeSortDropdown(); sortTrigger.focus(); return; }
        else return;
        e.preventDefault();
        options[targetIndex].focus();
      });

      sortDropdown.querySelectorAll('li').forEach(function (option) {
        option.addEventListener('click', function () {
          var sortValue = option.getAttribute('data-value');

          // Update selected state
          sortDropdown.querySelectorAll('li').forEach(function (li) {
            li.setAttribute('aria-selected', 'false');
          });
          option.setAttribute('aria-selected', 'true');

          // Update displayed value
          if (sortValueEl) {
            sortValueEl.textContent = option.textContent.trim();
          }

          closeSortDropdown();

          // Navigate to sorted URL
          var url = new URL(window.location.href);
          url.searchParams.set('sort_by', sortValue);
          window.location.assign(url.toString());
        });
      });

      // Close on click outside
      function handleClickOutside(e) {
        if (!sortTrigger.contains(e.target) && !sortDropdown.contains(e.target)) {
          closeSortDropdown();
        }
      }
      document.addEventListener('click', handleClickOutside);
    }

    /* ====================================================================
       Load More / Infinite Scroll
       Click handling is delegated to the section so the listener survives
       the pagination block being re-rendered after each load.
       ==================================================================== */
    var paginationType = section.getAttribute('data-pagination-type') || 'load_more';
    var loadMoreObserver = null;
    var loadingMore = false;
    var prefetch = null;

    function fetchPageHtml(url) {
      return fetch(url).then(function (response) { return response.text(); });
    }

    // Start (or reuse) a background fetch of whatever the current load-more
    // button points to, so the response is ready before it's needed. Only in
    // infinite mode — in button mode we wait for an explicit click.
    function prefetchNext() {
      if (paginationType !== 'infinite') return;
      var btn = section.querySelector('.oddit-section-main-collection__load-more');
      var url = btn && btn.getAttribute('href');
      if (!url) { prefetch = null; return; }
      if (prefetch && prefetch.url === url) return; // already buffered/in-flight
      var promise = fetchPageHtml(url);
      promise.catch(function () {}); // swallow if it's never consumed (no scroll)
      prefetch = { url: url, promise: promise };
    }

    // Append the fetched page's cards and refresh the pagination block.
    function applyNextPage(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newGrid = doc.querySelector('.oddit-section-main-collection__grid');
      var currentGrid = section.querySelector('.oddit-section-main-collection__grid');
      if (newGrid && currentGrid) {
        while (newGrid.children.length > 0) {
          currentGrid.appendChild(newGrid.children[0]);
        }
      }
      var newPagination = doc.querySelector('.oddit-section-main-collection__pagination');
      var currentPagination = section.querySelector('.oddit-section-main-collection__pagination');
      if (currentPagination && newPagination) {
        currentPagination.innerHTML = newPagination.innerHTML;
      } else if (currentPagination && !newPagination) {
        currentPagination.remove();
      }
      // Re-init carousels and lazy videos for new cards
      if (window.odditInitProductCards) window.odditInitProductCards(section);
    }

    function loadMore(loadMoreBtn) {
      if (loadingMore) return;
      var nextUrl = loadMoreBtn.getAttribute('href');
      if (!nextUrl) return;
      loadingMore = true;

      loadMoreBtn.textContent = 'Loading...';
      loadMoreBtn.style.pointerEvents = 'none';

      // Reuse the prefetched response when it matches; otherwise fetch now.
      var usingPrefetch = prefetch && prefetch.url === nextUrl;
      var source = usingPrefetch ? prefetch.promise : fetchPageHtml(nextUrl);
      prefetch = null;

      function done(html) {
        applyNextPage(html);
        loadingMore = false;
        observeLoadMore(); // re-arm on the new button
        prefetchNext(); // immediately buffer the following page
      }

      function fail() {
        loadMoreBtn.textContent = 'Error. Try again.';
        loadMoreBtn.style.pointerEvents = '';
        loadingMore = false;
      }

      source
        .then(done)
        .catch(function () {
          // A stale/failed prefetch shouldn't surface as an error — retry once
          // with a fresh fetch before giving up.
          if (usingPrefetch) {
            fetchPageHtml(nextUrl).then(done).catch(fail);
          } else {
            fail();
          }
        });
    }

    section.addEventListener('click', function (e) {
      var loadMoreBtn = e.target.closest('.oddit-section-main-collection__load-more');
      if (!loadMoreBtn) return;
      e.preventDefault();
      loadMore(loadMoreBtn);
    });

    // Infinite scroll: trigger the next load as the button nears the viewport.
    function observeLoadMore() {
      if (paginationType !== 'infinite' || !('IntersectionObserver' in window)) return;
      var btn = section.querySelector('.oddit-section-main-collection__load-more');
      if (!btn) return;
      if (loadMoreObserver) loadMoreObserver.disconnect();
      loadMoreObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            loadMoreObserver.disconnect();
            loadMore(btn);
          }
        });
      }, { rootMargin: '1200px 0px' });
      loadMoreObserver.observe(btn);
    }

    observeLoadMore();
    prefetchNext(); // buffer page 2 right away so the first load is instant

    /* ====================================================================
       Mobile Image Swipe Carousel — handled by global oddit-collection-product-card.js
       ==================================================================== */


    /* ====================================================================
       Collection Content Block Animations
       ==================================================================== */
    var animationObserver = null;

    function initBannerAnimations(root) {
      var banners = (root || section).querySelectorAll(
        '.oddit-section-main-collection__row-banner[data-animation]'
      );

      if (!banners.length) return;

      var reduceMotion = window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reduceMotion || !('IntersectionObserver' in window)) {
        banners.forEach(function (banner) {
          banner.classList.add('is-animation-ready', 'is-animated');
        });
        return;
      }

      if (animationObserver) animationObserver.disconnect();

      animationObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var banner = entry.target;
          var replay = banner.getAttribute('data-animation-replay') || 'once';

          if (entry.isIntersecting) {
            banner.classList.add('is-animated');

            if (replay === 'once') {
              animationObserver.unobserve(banner);
            }
          } else if (replay === 'repeat') {
            banner.classList.remove('is-animated');
          }
        });
      }, {
        threshold: window.matchMedia('(max-width: 989px)').matches ? 0.5 : 0.22,
        rootMargin: window.matchMedia('(max-width: 989px)').matches
          ? '0px 0px -12% 0px'
          : '0px 0px -8% 0px'
      });

      banners.forEach(function (banner) {
        var animation = banner.getAttribute('data-animation') || 'none';
        var trigger = banner.getAttribute('data-animation-trigger') || 'scroll';

        banner.classList.add('is-animation-ready');

        if (animation === 'none') {
          banner.classList.add('is-animated');
          return;
        }

        if (trigger === 'immediate') {
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              banner.classList.add('is-animated');
            });
          });
          return;
        }

        animationObserver.observe(banner);
      });
    }

    initBannerAnimations(section);

    // Store cleanup function
    section._cleanupSection = function () {
      document.removeEventListener('keydown', handleKeydown);
      if (typeof handleClickOutside === 'function') {
        document.removeEventListener('click', handleClickOutside);
      }
      if (loadMoreObserver) loadMoreObserver.disconnect();
      if (animationObserver) animationObserver.disconnect();
    };
  }

  // Initialize on DOMContentLoaded
  var section = document.querySelector('.oddit-section-main-collection');
  if (section) {
    initSection(section);
  }

  (function setupSortPortal() {
    var sortOnlyToolbar = document.querySelector('.oddit-section-main-collection__toolbar--sort-only');
    if (!sortOnlyToolbar) return;
    var sortEl = sortOnlyToolbar.querySelector('.oddit-section-main-collection__sort');
    var titleGroup = document.querySelector('.oddit-section-collection-header__title-group');
    if (!sortEl || !titleGroup) return;

    titleGroup.appendChild(sortEl);
    titleGroup.classList.add('has-portal-sort');
    // Mark the empty toolbar so CSS can collapse it deterministically
    // (the :empty selector won't match if Liquid leaves any whitespace).
    sortOnlyToolbar.classList.add('is-portaled');
  })();

  // Row banner video pause/play (WCAG 2.2.2). Delegated on document so it
  // keeps working after filter/sort re-render the grid. The button mirrors the
  // video's real state (autoplay can be blocked, e.g. Low Power Mode).
  (function () {
    var BTN = '[data-row-banner-pause]';
    function videoFor(btn) {
      var banner = btn.closest('.oddit-section-main-collection__row-banner');
      return banner && banner.querySelector('video');
    }
    function setState(btn, playing) {
      btn.setAttribute('data-state', playing ? 'playing' : 'paused');
      btn.setAttribute('aria-label', playing ? 'Pause background video' : 'Play background video');
    }
    function syncFromVideo(video) {
      var banner = video.closest('.oddit-section-main-collection__row-banner');
      var btn = banner && banner.querySelector(BTN);
      if (btn) setState(btn, !video.paused);
    }
    ['play', 'playing', 'pause', 'canplay'].forEach(function (type) {
      document.addEventListener(type, function (e) {
        if (e.target && e.target.classList && e.target.classList.contains('oddit-section-main-collection__row-banner-video')) {
          syncFromVideo(e.target);
        }
      }, true);
    });
    // Mobile: copy the accessiBe button's size and right edge (it loads after
    // first paint, so check for a few seconds and again on resize).
    function alignToAccessibe() {
      var host = document.querySelector('access-widget-ui');
      var trigger = host && host.shadowRoot && host.shadowRoot.querySelector('.trigger-button');
      var r = trigger && trigger.getBoundingClientRect();
      if (!r || !r.width) return false;
      var root = document.documentElement.style;
      root.setProperty('--row-banner-pause-size', Math.round(r.width) + 'px');
      root.setProperty('--row-banner-pause-right', Math.round(window.innerWidth - r.right) + 'px');
      return true;
    }
    if (document.querySelector(BTN)) {
      var alignTries = 0;
      var alignTimer = setInterval(function () {
        if (alignToAccessibe() || ++alignTries > 30) clearInterval(alignTimer);
      }, 500);
      var alignResize = null;
      window.addEventListener('resize', function () {
        clearTimeout(alignResize);
        alignResize = setTimeout(alignToAccessibe, 300);
      });
    }

    // Videos may have started (or been blocked) before this deferred script ran.
    document.querySelectorAll(BTN).forEach(function (btn) {
      var video = videoFor(btn);
      // Only once it has data; before that autoplay simply hasn't started yet.
      if (video && video.readyState >= 2) setState(btn, !video.paused);
    });
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest(BTN);
      if (!btn) return;
      var video = videoFor(btn);
      if (!video) return;
      if (video.paused) {
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () { setState(btn, false); });
      } else {
        video.pause();
      }
    });
  })();

  // Theme Editor support
  document.addEventListener('shopify:section:load', function (e) {
    var newSection = e.target.querySelector('.oddit-section-main-collection');
    if (newSection) {
      initSection(newSection);
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var oldSection = e.target.querySelector('.oddit-section-main-collection');
    if (oldSection && typeof oldSection._cleanupSection === 'function') {
      oldSection._cleanupSection();
    }
  });
})();
